import { Typography } from '@automata/ui';

export const Consistency = () => {
  return (
    <Typography variant={'body1'}>
      A consistency target defines two tasks as targets for consistent
      separation across batches. By default, consistency applies per piece of
      labware; this setting tells the solver to prioritize consistency between
      these tasks.
    </Typography>
  );
};
